<template>
    <modal
        name="modal-batch-delete-employees-form"
        class="modal--translation"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
        @before-close="beforeClose"
    >
        <!-- Error message display -->
        <div v-if="showError" class="error-message">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>
            </div>

            <div class="modal-body">
                <div class="d-flex align-items-center justify-content-center text-danger mb-3" v-if="errorItems.length === 0">
                    <i class="fal fa-times-circle fa-4x"></i>
                </div>
                <div class="d-flex align-items-center justify-content-center text-warning mb-3" v-else>
                    <i class="fal fa-exclamation-triangle fa-4x"></i>
                </div>

                <p class="text-center">{{ errorMessage }}</p>

                <div class="two-columns mt-5">
                    <ul v-if="errorItems.length > 0">
                        <li v-for="it in errorItems">
                            {{ it }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="!showError">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

                <h5 class="modal-title mb-0"><i class="fa fa-exclamation-triangle mr-2"></i> {{ trans('title') }}</h5>
            </div>

            <div class="modal-body p-0" :class="{'loading': loading }">
                <h6 v-if="mutEmployeesNames" class="head-title mb-4">
                    <i class="far fa-user mr-2"></i>
                    {{ mutEmployeesNames.join(', ') }}
                </h6>

                <p>{{ trans('description') }}</p>

                <form class="mt-4">
                    <div class="form-group">
                        <input class="form-check-input" type="checkbox" id="delete_confirmation_batch" v-model="deleteFromMyMcd" :value="deleteFromMyMcd" :class="{'disabled': loading }">
                        <label class="form-check-label" for="delete_confirmation_batch">{{ trans('delete_mymcd') }}</label>
                    </div>
                </form>
            </div>

            <div class="modal-footer text-center pt-4 d-flex justify-content-between">
                <div class="text-primary">
                    <b v-if="loading">
                        <i class="fa fa-fw fa-span fa-spinner mr-2"></i>
                        {{ trans('processing') }}
                    </b>
                </div>
                <b-button type="button" variant="danger" @click="submitForm()" :class="{'disabled': loading }"><i class="fa fa-check mr-2"></i> {{ trans('submit') }}</b-button>
            </div>
        </div>
    </modal>
</template>


<script>
import TranslationsUtils from "../../app-components/TranslationsUtils";
export default {
    mixins: [TranslationsUtils],

    props: {
        'url': {
            type: String
        },
        'employeesIds': {
            type: Number
        },
        'onsuccess': {
            type: Function
        },
    },

    data: function() {
        return {
            loading: false,
            deleteFromMyMcd: true,
            mutEmployeesIds: this.employeesIds,
            mutEmployeesNames: [],
            errorMessage: "",
            errorItems: [],
            showError: false
        };
    },

    methods: {
        open(ids, employees) {
            this.mutEmployeesIds = ids;
            this.mutEmployeesNames = [];
            if(employees) {
                this.mutEmployeesNames = employees.map(x => x.full_name);
            }

            this.$modal.show('modal-batch-delete-employees-form');
        },

        submitForm() {
            this.loading = true;

            axios.delete(this.url, {data: { ids: this.mutEmployeesIds, deleteFromMymcd: this.deleteFromMyMcd } })
                .then(success => {
                    this.loading = false;

                    if(success.data.error) {
                        this.showError = true;
                        this.errorMessage = success.data.error;
                        this.errorItems = success.data.errorItems ? success.data.errorItems : [];
                    } else {
                        this.closeModal();
                        this.$notify({ type: 'success', title: success.data.message });
                    }

                    if(typeof this.onsuccess !== 'undefined') {
                        this.onsuccess();
                    }
                })
                .catch(error => {
                    if(error.response) {
                        this.errorMessage = error.response.data.error;
                        this.showError = true;
                    }
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('modal-batch-delete-employees-form');
            this.showError = false;
            this.errorItems = [];
            this.errorMessage = "";
        },

        // docs (example): https://github.com/euvl/vue-js-modal/blob/master/demo/src/components/Modal_Error.vue
        beforeClose(event) {
            if(this.loading) {
                event.stop();
                return false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
        line-height: 150%;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }

    .two-columns {
        column-count: 2;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/employee/modals/BatchDeleteEmployeesForm.vue